import { WarrantyT } from '@lambda/apis/src/warranty/types';

/**
 * ReebeloCare plan display helpers.
 *
 * We only support displaying a per-month price, and a duration in months:
 * ReebeloCare plans are sold in months. A plan in any other unit (MsWarranty
 * also knows `Days` and `Weeks`) gets neither, rather than a figure computed as
 * if its duration were in months.
 */

/** The plan's length in months, or null when it isn't sold in months. */
export const getPlanMonths = (plan: WarrantyT): number | null =>
  String(plan.durationUnits) === 'Months' && plan.duration > 0
    ? plan.duration
    : null;

/** What the plan costs per month, or null when it isn't sold in months. */
export const getPlanMonthlyPrice = (plan: WarrantyT): number | null => {
  const months = getPlanMonths(plan);

  return months ? plan.price / months : null;
};
